import * as React from 'react';
import { connect } from 'react-redux';

import { WindowContext } from '../contexts/WindowContext';
import { NotificationCard } from '../components/NotificationCard/NotificationCard';
import { StackEffect } from '../components/StackEffect/StackEffect';
import { ResizeWrapper, MeasureMode } from '../components/Wrappers/ResizeWrapper';
import { RootState } from '../../store/State';
import { Point } from '../../controller/LayoutableWindow';
import { GlobalProviderStyles } from '../styles/GlobalProviderStyles';

import { StoredNotification } from '../../model/StoredNotification';
import { getStickyNotifications } from '../../store/partials/Notification';

export interface ToastAppProps {
  notificationId: string;
  /**
   * Set the window size. This is called once the content has fully loaded and measured.
   */
  setWindowSize: (dimensions: Point) => void;
  /**
   * Callback invoked when the window's content has changed and the toast stack needs a relayout.
   */
  onResize?: (dimensions: Point) => void;
  /**
   * Callback invoked when a component wants to modify the size of the window without changing the base size.
   */
  onModifySize?: (dimensions: Point) => void;
}

type ToastAppComponentProps = {
  notification?: StoredNotification;
} & ToastAppProps &
  ReturnType<typeof mapStateToProps>;

const ToastAppComponent: React.FC<ToastAppComponentProps> = (props) => {
  const { setWindowSize, onResize, onModifySize, notificationId, notification, stackCount } = props;
  if (!notification) {
    console.warn(`Notification not in store for id: ${notificationId}`);
    return null;
  }
  const context = React.useContext(WindowContext);

  React.useEffect(() => {
    context.document.title = notification.id;
  }, [notification.id]);

  return (
    <>
      <GlobalProviderStyles />
      <ResizeWrapper
        onResize={onResize}
        onModifySize={onModifySize}
        onSize={setWindowSize}
        mode={MeasureMode.CONSTANT}
      >
        <StackEffect depth={stackCount}>
          <NotificationCard notification={notification} isToast={true} stackSize={stackCount} />
        </StackEffect>
      </ResizeWrapper>
    </>
  );
};

const mapStateToProps = (state: RootState, { notificationId }: ToastAppProps) => {
  /**
   * always use latest store Notification otherwise Updates do not work.
   */
  const notification = state.notifications.find((not) => not.id === notificationId);

  return {
    notification,
    stackCount:
      notification?.notification.sticky === 'sticky' ? getStickyNotifications(state).length : 0,
  };
};

export const ToastApp = connect(mapStateToProps)(ToastAppComponent);
